import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { LayoutSingleColumn, Page } from '../../components';
import { useConfiguration } from '../../context/configurationContext';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { blogArticles } from '../BlogArticlePage/BlogArticlePage.config';

import css from './BlogHubPage.module.css';

const articleCategories = [
  {
    title: 'Flower meanings',
    text: 'Learn what different flowers and colors mean before you choose a bouquet.',
  },
  {
    title: 'Seasonal guides',
    text: 'Find timely ideas for Valentine’s Day, Mother’s Day, birthdays, and other key moments.',
  },
  {
    title: 'Gift ideas',
    text: 'Browse practical gift guides, romantic ideas, and thoughtful flower suggestions.',
  },
  {
    title: 'Birth flowers',
    text:
      'Move month by month through birth flowers and find ideas that feel personal from the start.',
  },
];

const featuredArticles = [
  {
    label: 'Seasonal guide',
    title: 'National Flower Day in Canada',
    excerpt:
      'See when National Flower Day happens in Canada and get easy ideas for celebrating with fresh blooms.',
    path: '/blog/national-flower-day-canada',
  },
  {
    label: 'Popular flowers',
    title: '15 Most Popular Flowers in Canada',
    excerpt:
      'Meet the flowers Canadians love most, from classic roses to everyday favorites worth gifting.',
    path: '/blog/15-most-popular-flowers-canada',
  },
  {
    label: 'Indoor plants',
    title: '12 Beautiful Indoor Blooming Plants',
    excerpt:
      'Discover indoor blooming plants that add color at home and still make thoughtful gifts.',
    path: '/blog/12-beautiful-indoor-blooming-plants',
  },
  {
    label: 'Birth flowers',
    title: 'January Birth Flower',
    excerpt:
      'Learn why carnations represent January and which colors work best for birthday gifting.',
    path: '/blog/january-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'February Birth Flower',
    excerpt: 'Explore the meaning of violets and why they make such a sweet February birth flower.',
    path: '/blog/february-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'March Birth Flower',
    excerpt:
      'See why daffodils represent March and why they feel so closely tied to spring birthdays.',
    path: '/blog/march-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'April Birth Flower',
    excerpt:
      'See how daisies and sweet peas shape the meaning of April birthday flowers and spring gifting.',
    path: '/blog/april-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'May Birth Flower',
    excerpt:
      'Learn how lily of the valley and hawthorn shape the softer, fuller feeling of May birthday flowers.',
    path: '/blog/may-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'June Birth Flower',
    excerpt:
      'Explore how rose and honeysuckle give June birthday flowers their lush, affectionate, early-summer feeling.',
    path: '/blog/june-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'July Birth Flower',
    excerpt:
      'Learn how larkspur and water lily give July birthday flowers their bright, graceful, midsummer feeling.',
    path: '/blog/july-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'August Birth Flower',
    excerpt:
      'See how gladiolus and poppy shape the bolder, warmer, more layered feeling of August birthday flowers.',
    path: '/blog/august-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'September Birth Flower',
    excerpt:
      'Learn how aster and morning glory give September birthday flowers their thoughtful, steady, gently renewing feeling.',
    path: '/blog/september-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'October Birth Flower',
    excerpt:
      'See how cosmos and marigold give October birthday flowers their balanced, warm, richly autumn feeling.',
    path: '/blog/october-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'November Birth Flower',
    excerpt:
      'See how peony and chrysanthemum shape the softer, warmer, more grounded feeling of November birthday flowers.',
    path: '/blog/november-birth-flower',
  },
  {
    label: 'Birth flowers',
    title: 'December Birth Flower',
    excerpt:
      'See how holly and narcissus give December birthday flowers their protective, hopeful, winter-bright feeling.',
    path: '/blog/december-birth-flower',
  },
  {
    label: 'Relationship ideas',
    title: 'How to Ask Someone to Be Your Valentine',
    excerpt:
      'Get simple, sweet ideas for asking someone to be your Valentine with flowers and gifts.',
    path: '/blog/how-to-ask-someone-to-be-your-valentine',
  },
  {
    label: 'Seasonal guide',
    title: "Valentine's Day in Canada",
    excerpt:
      'See when Valentine’s Day happens in Canada, how people celebrate it, and which flowers are most popular to send.',
    path: '/blog/valentines-day-canada',
  },
  {
    label: 'Seasonal guide',
    title: "When Is Mother's Day in Canada?",
    excerpt:
      "See the 2026 Mother's Day date in Canada, how people usually celebrate, and why flowers stay at the center of the holiday.",
    path: '/blog/when-is-mothers-day-in-canada',
  },
  {
    label: 'Gift ideas',
    title: 'Bridal Shower Ideas Toronto',
    excerpt:
      'Plan a polished Toronto bridal shower with flowers, balloons, food, gifts, timing, and simple decor ideas that actually work.',
    path: '/blog/bridal-shower-ideas-toronto',
  },
  {
    label: 'Balloon guide',
    title: 'How Long Do Helium Balloons Last?',
    excerpt:
      'Get a practical, honest answer on latex vs foil balloons, what heat changes, and how to time a setup without guessing.',
    path: '/blog/how-long-do-helium-balloons-last',
  },
  {
    label: 'Balloon guide',
    title: 'How to Deflate Foil Balloons',
    excerpt:
      'Learn the calm, reusable way to find the valve, use a straw correctly, and store foil balloons without ruining them.',
    path: '/blog/how-to-deflate-foil-balloons',
  },
  {
    label: 'Flower meaning hub',
    title: 'Flower Meanings Guide',
    excerpt:
      'Browse all of our Meaning of ... flower pages in one place and start from the feeling you want the bouquet to carry.',
    path: '/blog/flower-meanings',
  },
  {
    label: 'Birth flower hub',
    title: 'Birth Flowers by Month',
    excerpt:
      'Browse all 12 birth flower guides in one place and jump straight to the month you need.',
    path: '/blog/birth-flowers-by-month',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Red Roses',
    excerpt:
      'Understand what red roses say in romantic moments, special occasions, and classic gifting.',
    path: '/blog/meaning-of-red-roses',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Yellow Roses',
    excerpt:
      'See what yellow roses symbolize and when they work best as cheerful, friendship-forward flowers.',
    path: '/blog/meaning-of-yellow-roses',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Snowdrops',
    excerpt:
      'Learn why snowdrops are tied to hope, renewal, and the quiet strength of winter turning toward spring.',
    path: '/blog/meaning-of-snowdrops',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Carnations',
    excerpt:
      'Understand what carnations symbolize, how color changes the message, and why they work so well in thoughtful gifts.',
    path: '/blog/meaning-of-carnations',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Primroses',
    excerpt:
      'Learn why primroses are tied to tenderness, warmth, and the soft beginning of something hopeful.',
    path: '/blog/meaning-of-primroses',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Violets',
    excerpt:
      'See why violets are linked with loyalty, sincerity, and a quiet kind of affection that lasts.',
    path: '/blog/meaning-of-violets',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Daffodil',
    excerpt:
      'Learn why daffodils are tied to hope, renewal, and the first real feeling of spring beginning again.',
    path: '/blog/meaning-of-daffodil',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Sweet Pea',
    excerpt:
      'See why sweet peas are tied to gratitude, gentle affection, and a softer more personal kind of spring warmth.',
    path: '/blog/meaning-of-sweet-pea',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Daisy',
    excerpt:
      'Learn why daisies feel so bright, honest, and easy to love in spring bouquets and meaningful gifts.',
    path: '/blog/meaning-of-daisy',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Hawthorn',
    excerpt:
      'See why hawthorn is tied to hope, protection, and a more rooted, lasting kind of spring beauty.',
    path: '/blog/meaning-of-hawthorn',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Lily of the Valley',
    excerpt:
      'Learn why lily of the valley feels so tender, refined, and closely linked to the return of happiness.',
    path: '/blog/meaning-of-lily-of-the-valley',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of White Lilies',
    excerpt:
      'See why white lilies feel so calm, sincere, and elegant, from sympathy flowers to thoughtful gifts.',
    path: '/blog/meaning-of-white-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Pink Lilies',
    excerpt:
      'Learn why pink lilies feel affectionate, graceful, warm, and easy to send for thoughtful gifts.',
    path: '/blog/meaning-of-pink-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Yellow Lilies',
    excerpt:
      'Learn why yellow lilies feel joyful, grateful, optimistic, and warmly generous in real bouquets.',
    path: '/blog/meaning-of-yellow-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Orange Lilies',
    excerpt:
      'Learn why orange lilies feel confident, energetic, passionate, warm, and made for celebration.',
    path: '/blog/meaning-of-orange-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Red Lilies',
    excerpt:
      'Learn why red lilies feel passionate, dramatic, romantic, confident, and emotionally powerful.',
    path: '/blog/meaning-of-red-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Purple Lilies',
    excerpt:
      'Learn why purple lilies feel admired, dignified, refined, mysterious, and quietly luxurious.',
    path: '/blog/meaning-of-purple-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Black Lilies',
    excerpt:
      'Learn why black lilies feel mysterious, rare, powerful, dramatic, and quietly elegant.',
    path: '/blog/meaning-of-black-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Calla Lilies',
    excerpt:
      'Learn why calla lilies feel elegant, graceful, sincere, modern, and quietly luxurious.',
    path: '/blog/meaning-of-calla-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Stargazer Lilies',
    excerpt:
      'Learn why stargazer lilies feel romantic, ambitious, admired, luxurious, and unforgettable.',
    path: '/blog/meaning-of-stargazer-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Tiger Lilies',
    excerpt:
      'Learn why tiger lilies feel confident, proud, abundant, bold, energetic, and memorable.',
    path: '/blog/meaning-of-tiger-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Easter Lilies',
    excerpt:
      'Learn why Easter lilies feel hopeful, peaceful, pure, renewed, graceful, and spring-like.',
    path: '/blog/meaning-of-easter-lilies',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Orchids',
    excerpt:
      'Learn why orchids feel elegant, thoughtful, luxurious, graceful, and beautifully long-lasting.',
    path: '/blog/meaning-of-orchids',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Hydrangeas',
    excerpt:
      'Learn why hydrangeas feel grateful, graceful, abundant, emotional, and deeply thoughtful.',
    path: '/blog/meaning-of-hydrangeas',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Honeysuckle',
    excerpt:
      'See why honeysuckle is tied to devotion, warmth, and a softer, more naturally growing kind of affection.',
    path: '/blog/meaning-of-honeysuckle',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Rose',
    excerpt:
      'Learn why roses still carry so much feeling, from beauty and devotion to admiration and timeless emotional depth.',
    path: '/blog/meaning-of-rose',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Water Lily',
    excerpt:
      'See why water lilies are tied to peace, grace, emotional depth, and a calmer kind of beauty.',
    path: '/blog/meaning-of-water-lily',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Larkspur',
    excerpt:
      'Learn why larkspur feels so joyful, open, and bright, with a midsummer energy that is easy to love.',
    path: '/blog/meaning-of-larkspur',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Poppy',
    excerpt:
      'See why poppies feel so soft, memorable, and full of beauty with a more poetic emotional warmth underneath.',
    path: '/blog/meaning-of-poppy',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Gladiolus',
    excerpt:
      'Learn why gladiolus is tied to strength, sincerity, and a kind of bold summer clarity that still feels human.',
    path: '/blog/meaning-of-gladiolus',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Morning Glory',
    excerpt:
      'See why morning glory feels so fresh, tender, and hopeful, with renewal built right into its rhythm.',
    path: '/blog/meaning-of-morning-glory',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Aster',
    excerpt:
      'Learn why asters feel so calm, affectionate, and composed, with a thoughtful early-fall beauty that lasts.',
    path: '/blog/meaning-of-aster',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Cosmos',
    excerpt:
      'See why cosmos feels so balanced, open, and graceful, with a calmer kind of beauty that gives bouquets room to breathe.',
    path: '/blog/meaning-of-cosmos',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Marigold',
    excerpt:
      'Learn why marigolds feel so warm, vivid, and alive, with an autumn richness that makes gifts more memorable.',
    path: '/blog/meaning-of-marigold',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Peony',
    excerpt:
      'See why peonies feel so lush, generous, and open-hearted, with a softness that makes gifts feel immediately personal.',
    path: '/blog/meaning-of-peony',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Chrysanthemum',
    excerpt:
      'Learn why chrysanthemums feel so warm, steady, and sincere, with a grounded beauty that suits heartfelt gifts.',
    path: '/blog/meaning-of-chrysanthemum',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Holly',
    excerpt:
      'See why holly feels so protective, resilient, and deeply winter-rooted, with warmth that holds through the season.',
    path: '/blog/meaning-of-holly',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Narcissus',
    excerpt:
      'Learn why narcissus feels so hopeful and bright, with the kind of renewal that gently carries people through winter.',
    path: '/blog/meaning-of-narcissus',
  },
  {
    label: 'Gift ideas',
    title: 'What to Write on a Sympathy Card (60+ Examples)',
    excerpt:
      'Real, human sympathy card messages for funeral flowers and beyond — short, heartfelt, religious, professional, and for specific losses.',
    path: '/blog/sympathy-card-messages',
  },
  {
    label: 'Flower care',
    title: 'How to Keep Cut Flowers Fresh',
    excerpt:
      'A working florist guide to making cut flowers last 7-10 days: stem cuts, water care, vase placement, and which old tricks actually help.',
    path: '/blog/how-to-keep-cut-flowers-fresh',
  },
  {
    label: 'Flower care',
    title: 'How to Make Flowers Last Longer',
    excerpt:
      "Beyond the basics: the fridge trick, ethylene control, and the florist techniques that push a bouquet from 7 days to 14.",
    path: '/blog/how-to-make-flowers-last-longer',
  },
  {
    label: 'Flower care',
    title: 'How Long Do Cut Flowers Last?',
    excerpt:
      'A realistic vase-life breakdown by variety — roses, tulips, lilies, peonies, hydrangeas — plus how long flowers survive without water.',
    path: '/blog/how-long-do-cut-flowers-last',
  },
  {
    label: 'Flower care',
    title: 'What to Put in Flower Water',
    excerpt:
      'Flower food, sugar, vinegar, bleach, 7-Up: which additives actually extend vase life, with a tested DIY recipe.',
    path: '/blog/what-to-put-in-flower-water',
  },
  {
    label: 'Flower care',
    title: 'How to Care for Fresh Flowers (Day 1 Routine)',
    excerpt:
      'A practical first-day routine: unwrapping, vase prep, stem cuts, placement — the order matters more than people think.',
    path: '/blog/how-to-care-for-fresh-flowers',
  },
  {
    label: 'Occasions',
    title: 'Best Flowers for an Anniversary',
    excerpt:
      'Year-by-year anniversary flower picks, how many roses to send, and same-day delivery options in Toronto and the GTA.',
    path: '/blog/flowers-for-anniversary',
  },
  {
    label: 'Occasions',
    title: 'Best Flowers for a Birthday',
    excerpt:
      'A practical guide to birthday flowers by personality, relationship, and milestone — plus how to handle same-day delivery in Toronto.',
    path: '/blog/flowers-for-birthday',
  },
  {
    label: 'Occasions',
    title: 'Best Flowers for Get Well',
    excerpt:
      'Hospital-safe flowers, what to avoid, Toronto ward rules (ICU, oncology, NICU), and alternatives when fresh flowers are not allowed.',
    path: '/blog/flowers-for-get-well',
  },
  {
    label: 'Occasions',
    title: 'Best Flowers for a New Baby',
    excerpt:
      'Soft, low-fragrance bouquets for new moms, gender-neutral colour ideas, hospital vs home delivery, and when to send.',
    path: '/blog/flowers-for-new-baby',
  },
  {
    label: 'Occasions',
    title: 'Best Flowers for a Housewarming',
    excerpt:
      'Flowers vs plants for a new home, what fits a condo vs a family home, add-ons that pair well, and same-day delivery in Toronto.',
    path: '/blog/flowers-for-housewarming',
  },
  {
    label: 'Seasonal',
    title: 'Best Spring Flowers',
    excerpt:
      'Tulips, daffodils, ranunculus, peonies — what is actually in season March through May in Canada, and how to order in Toronto.',
    path: '/blog/spring-flowers',
  },
  {
    label: 'Seasonal',
    title: 'Best Summer Flowers',
    excerpt:
      'Sunflowers, dahlias, hydrangeas, garden roses — June through August, summer weddings, outdoor entertaining, and heat-care tips.',
    path: '/blog/summer-flowers',
  },
  {
    label: 'Seasonal',
    title: 'Best Fall Flowers',
    excerpt:
      'Chrysanthemums, dahlias, asters — the warm autumn palette, Thanksgiving bouquets, fall weddings, and same-day GTA delivery.',
    path: '/blog/fall-flowers',
  },
  {
    label: 'Seasonal',
    title: 'Best Winter Flowers',
    excerpt:
      'Amaryllis, paperwhites, hellebore, holly — December through February, holiday picks, and how to deliver flowers in Toronto cold.',
    path: '/blog/winter-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Types of Flowers',
    excerpt:
      'A practical hub for choosing the right bouquet by season, colour, shape, and fragrance — with links into the seasonal and meaning guides.',
    path: '/blog/types-of-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Red Flowers',
    excerpt:
      'Top red flower varieties, what red means, shade differences, stem count for roses, and where to order in Toronto.',
    path: '/blog/red-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Pink Flowers',
    excerpt:
      'The most versatile colour in flowers — by shade, by occasion, and which pink varieties fit which gesture.',
    path: '/blog/pink-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Yellow Flowers',
    excerpt:
      'The friendship colour. Top yellow varieties, when yellow lands best, get-well and thank-you gifting in Toronto.',
    path: '/blog/yellow-flowers',
  },
  {
    label: 'Flower colours',
    title: 'White Flowers',
    excerpt:
      'The most formal colour in flowers — weddings, sympathy, and modern home decor. Which whites to pick and where to order.',
    path: '/blog/white-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Purple Flowers',
    excerpt:
      'Purple reads as admiration and quiet luxury. Top purple varieties, graduations and promotions, and where to order in Toronto.',
    path: '/blog/purple-flowers',
  },
  {
    label: 'Seasonal',
    title: 'Best Christmas Flowers',
    excerpt:
      'Red roses, amaryllis, white lilies, poinsettias — the holiday palette, gift ideas, and timing for Toronto deliveries.',
    path: '/blog/christmas-flowers',
  },
  {
    label: 'Seasonal',
    title: 'Best Easter Flowers',
    excerpt:
      'Easter lilies, tulips, daffodils — what to send for spring religious occasions, family Easter dinner, and gifting in Toronto.',
    path: '/blog/easter-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Types of Roses',
    excerpt:
      'Hybrid teas, garden roses, spray roses, floribunda — a practical guide to picking the right rose for a bouquet or wedding.',
    path: '/blog/types-of-roses',
  },
  {
    label: 'Flower guide',
    title: 'Best Smelling Flowers',
    excerpt:
      'The 12 most fragrant flowers (and the ones that are surprisingly unscented), plus when fragrance helps and when it does not.',
    path: '/blog/best-smelling-flowers',
  },
  {
    label: 'Occasions',
    title: 'Flowers for a Funeral',
    excerpt:
      'Practical funeral flower etiquette: appropriate varieties, arrangement types, religious considerations, what to write on the card.',
    path: '/blog/flowers-for-funeral',
  },
  {
    label: 'Flower colours',
    title: 'Blue Flowers',
    excerpt:
      'True blue flowers are rare in nature. Which varieties are genuinely blue, what blue means, and how to order in Toronto.',
    path: '/blog/blue-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Orange Flowers',
    excerpt:
      'Top orange varieties, the warm-shade vocabulary, fall and modern wedding palettes, and where to order in Toronto.',
    path: '/blog/orange-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Tropical Flowers',
    excerpt:
      'Bird of paradise, anthurium, orchids, heliconia — dramatic imported varieties that last 10-14 days in the vase.',
    path: '/blog/tropical-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Exotic Flowers',
    excerpt:
      'Protea, anthurium, Cymbidium orchids, heritage roses — when exotic earns the premium and how to source in Toronto.',
    path: '/blog/exotic-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Types of Tulips',
    excerpt:
      'Single, double / peony, parrot, fringed, lily-flowered — the main tulip varieties and how to pick for a spring bouquet.',
    path: '/blog/types-of-tulips',
  },
  {
    label: 'Flower colours',
    title: 'Green Flowers',
    excerpt:
      'Bells of Ireland, green hydrangea, green roses — the modern green-and-white aesthetic and when green bouquets work.',
    path: '/blog/green-flowers',
  },
  {
    label: 'Flower colours',
    title: 'Black Flowers',
    excerpt:
      'True black flowers do not exist — the darkest natural varieties. Black calla lily, Queen of Night tulip, Black Magic rose.',
    path: '/blog/black-flowers',
  },
  {
    label: 'Flower formats',
    title: 'Dried Flowers',
    excerpt:
      'Pampas grass, lavender, eucalyptus, statice — the modern dried aesthetic, how they are made, and care tips.',
    path: '/blog/dried-flowers',
  },
  {
    label: 'Flower formats',
    title: 'Forever Roses',
    excerpt:
      'Preserved roses in luxury boxes — how they are made, how long they last, when the format makes the right gift.',
    path: '/blog/forever-roses',
  },
  {
    label: 'Flower formats',
    title: 'Preserved Flowers',
    excerpt:
      'Real flowers treated with glycerin to last 1-3 years. The difference from dried, the technique, and when preserved fits.',
    path: '/blog/preserved-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Rose Petals',
    excerpt:
      'Fresh, dried, freeze-dried — how much you need for baths, weddings, scatters, and where to source in Toronto.',
    path: '/blog/rose-petals',
  },
  {
    label: 'Flower formats',
    title: 'Artificial Flowers',
    excerpt:
      'Silk, latex / real-touch, foam, plastic — when artificial makes sense, quality cues, and where to find good ones in Toronto.',
    path: '/blog/artificial-flowers',
  },
  {
    label: 'Occasions',
    title: 'Flowers for Graduation',
    excerpt:
      'Bright photogenic picks, school colour matching, by-level guide, and grad-day logistics for the GTA.',
    path: '/blog/flowers-for-graduation',
  },
  {
    label: 'Flower guide',
    title: 'Types of Peonies',
    excerpt:
      'Herbaceous, tree, intersectional; single, double, bomb, anemone — the main peony types and how to pick.',
    path: '/blog/types-of-peonies',
  },
  {
    label: 'Flower guide',
    title: 'Flowers That Look Like Roses',
    excerpt:
      'Ranunculus, lisianthus, peonies, garden roses — the best rose alternatives by season, vase life, and price.',
    path: '/blog/flowers-that-look-like-roses',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of White Roses',
    excerpt:
      'Purity, sincerity, weddings, and sympathy — the dual meaning of white roses and when each context applies.',
    path: '/blog/meaning-of-white-roses',
  },
  {
    label: 'Flower meaning',
    title: 'Meaning of Pink Roses',
    excerpt:
      'Admiration, gratitude, grace — what pink roses say, by shade, and the safest rose colour for non-romantic gifting.',
    path: '/blog/meaning-of-pink-roses',
  },
  {
    label: 'Flower meaning',
    title: 'Rose Color Meaning',
    excerpt:
      'A complete guide to what each rose colour says: red, white, yellow, pink, orange, peach, purple, black, and mixed.',
    path: '/blog/rose-color-meaning',
  },
  {
    label: 'Flower meaning',
    title: 'Number of Roses Meaning',
    excerpt:
      '1, 3, 12, 24, 100 — what the number of roses says, by count, plus when the count matters less than the colour.',
    path: '/blog/number-of-roses-meaning',
  },
  {
    label: 'Flower guide',
    title: 'Types of Sunflowers',
    excerpt:
      'Tall, branching, dwarf — plus the surprising colour range. Red, burgundy, chocolate, and white sunflowers exist.',
    path: '/blog/types-of-sunflowers',
  },
  {
    label: 'Flower care',
    title: 'How to Dry Flowers',
    excerpt:
      'Four methods: air drying, silica gel, pressing, microwave. Which flowers work best with each method and how long they take.',
    path: '/blog/how-to-dry-flowers',
  },
  {
    label: 'Flower guide',
    title: 'Wildflower Bouquet',
    excerpt:
      'The loose, hand-tied, garden-style look. Which flowers count, how to build one, and where to order in Toronto.',
    path: '/blog/wildflower-bouquet',
  },
  {
    label: 'Flower care',
    title: 'How to Dry Roses',
    excerpt:
      'Step-by-step guide to preserving sentimental rose bouquets: air drying, silica gel, microwave. When to start and what to expect.',
    path: '/blog/how-to-dry-roses',
  },
  {
    label: 'Flower care',
    title: 'How to Wrap Flowers',
    excerpt:
      'Florist techniques for hand-tied bouquets, gift wraps, and wet wraps for transport. Materials cheat sheet and common mistakes.',
    path: '/blog/how-to-wrap-flowers',
  },
  {
    label: 'Flower formats',
    title: 'Flower Preservation',
    excerpt:
      'Six methods compared: drying, pressing, silica, glycerin, freeze-drying, resin. DIY vs professional, costs, and best by flower type.',
    path: '/blog/flower-preservation',
  },
  {
    label: 'Gifting guide',
    title: 'Apology Flowers: How to Say Sorry',
    excerpt:
      'The best flowers to say sorry, what the colours mean, how many to send, and exactly what to write on the card.',
    path: '/blog/apology-flowers',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Orchids',
    excerpt:
      'Orchids are easier than their reputation - the right way to water, light, repot, and get a phalaenopsis to rebloom for years.',
    path: '/blog/how-to-care-for-orchids',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Tulips',
    excerpt:
      'Why tulips keep growing and bending in the vase, the cold shallow water trick, and how to fix a droopy bunch fast.',
    path: '/blog/how-to-care-for-tulips',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Peonies',
    excerpt:
      'The marshmallow test, how to coax tight buds into full blooms, and how to pace peonies to your schedule.',
    path: '/blog/how-to-care-for-peonies',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Hydrangeas',
    excerpt:
      'Why hydrangeas wilt so fast, the underwater revival trick that actually works, and how to keep the big blooms firm.',
    path: '/blog/how-to-care-for-hydrangeas',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Roses',
    excerpt:
      'The angled cut, clean water and flower food, reviving bent-neck roses, and getting two weeks out of a bouquet.',
    path: '/blog/how-to-care-for-roses',
  },
  {
    label: 'Buyer guide',
    title: 'How Much Do Flowers Cost in Canada?',
    excerpt:
      'What flowers really cost, what drives the price, and how grocery, florist and online chains compare - plus how to get more for your money.',
    path: '/blog/how-much-do-flowers-cost',
  },
  {
    label: 'Buyer guide',
    title: 'How to Choose a Local Florist',
    excerpt:
      'Why the florist matters more than the flowers, how local shops beat the chains, what to look for, and the red flags to avoid.',
    path: '/blog/how-to-choose-a-florist',
  },
  {
    label: 'Gifting guide',
    title: 'Best Flowers for a First Date',
    excerpt:
      'Should you bring flowers on a first date, and what? The honest guide - why small and simple almost always wins.',
    path: '/blog/best-flowers-for-a-first-date',
  },
  {
    label: 'Wedding guide',
    title: 'Wedding Flowers on a Budget',
    excerpt:
      'What wedding flowers really cost, where to save and where to splurge, and how seasonal blooms cut the bill.',
    path: '/blog/wedding-flowers-on-a-budget',
  },
  {
    label: 'Buyer guide',
    title: 'Are Flower Subscriptions Worth It?',
    excerpt:
      'An honest look at flower subscriptions - the real pros and cons, who they suit, and how the cost compares to one-off bouquets.',
    path: '/blog/are-flower-subscriptions-worth-it',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Sunflowers',
    excerpt:
      'Sunflowers are heavy drinkers - how much water they really need, why they droop, and getting up to two weeks of cheerful blooms.',
    path: '/blog/how-to-care-for-sunflowers',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Cut Lilies',
    excerpt:
      'Why to remove the pollen, buying in bud for a rolling display, and the important warning every cat owner needs to know.',
    path: '/blog/how-to-care-for-lilies',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Carnations',
    excerpt:
      'The most underrated, longest-lasting flower there is - cut between the nodes, keep fruit away, and get two to three weeks.',
    path: '/blog/how-to-care-for-carnations',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Gerbera Daisies',
    excerpt:
      'Why those bright heads flop over, the shallow clean-water fix, and how to keep gerberas standing tall for a week or more.',
    path: '/blog/how-to-care-for-gerbera-daisies',
  },
  {
    label: 'Care guide',
    title: 'How to Care for Ranunculus',
    excerpt:
      'Delicate layered blooms with simple needs - buy them in coloured bud, keep them cool, and watch them open into full globes.',
    path: '/blog/how-to-care-for-ranunculus',
  },
  {
    label: 'Seasonal guide',
    title: "Best Flowers for Mother's Day in Canada",
    excerpt:
      'What to actually give: the classic and modern picks, what the colours say, what to write on the card, and how to deliver on time.',
    path: '/blog/best-flowers-for-mothers-day',
  },
  {
    label: 'Seasonal guide',
    title: "Father's Day Flowers in Canada",
    excerpt:
      'Yes, flowers for dad - you just choose differently. Bold blooms, low-maintenance plants, and how to get the tone right.',
    path: '/blog/fathers-day-flowers-canada',
  },
  {
    label: 'Seasonal guide',
    title: 'Canadian Thanksgiving Flowers',
    excerpt:
      'Autumn is peak flower season - the best warm-toned blooms, a low centrepiece that does not block conversation, and hostess-gift ideas.',
    path: '/blog/thanksgiving-flowers-canada',
  },
  {
    label: 'Seasonal guide',
    title: 'Remembrance Day Flowers & the Poppy',
    excerpt:
      'Why the poppy became the flower of remembrance, the blooms used in wreaths, how to wear it, and thoughtful ways to mark November 11.',
    path: '/blog/remembrance-day-flowers',
  },
  {
    label: 'Seasonal guide',
    title: 'Canada Day Flowers & Décor',
    excerpt:
      'Red and white, straight off the flag - the best sturdy summer blooms and easy table ideas that look festive without trying too hard.',
    path: '/blog/canada-day-flowers',
  },
  {
    label: 'Seasonal guide',
    title: 'Lunar New Year Flowers',
    excerpt:
      'Flowers as wishes for the year - plum blossom, orchids, peonies and kumquat, what each lucky bloom means, and how to display them.',
    path: '/blog/lunar-new-year-flowers',
  },
  {
    label: 'Seasonal guide',
    title: 'Diwali Flowers',
    excerpt:
      'Marigolds, meaning and décor for the festival of lights - the flowers of Diwali, how to make toran and rangoli, and decorating the home.',
    path: '/blog/diwali-flowers',
  },
  {
    label: 'Craft guide',
    title: 'How to Press Flowers',
    excerpt:
      'Four easy pressing methods - book, iron, microwave and press - which flowers keep their colour, and craft ideas for the results.',
    path: '/blog/how-to-press-flowers',
  },
  {
    label: 'Care guide',
    title: 'Flowers Toxic to Cats & Dogs',
    excerpt:
      'Which bouquet flowers are dangerous for pets (lilies top the list), which are safe, symptoms to watch for, and pet-safe bouquet ideas.',
    path: '/blog/flowers-toxic-to-cats',
  },
  {
    label: 'Seasonal guide',
    title: 'Nowruz Flowers',
    excerpt:
      'Hyacinths, tulips and blossom branches - the flowers of Persian New Year, what belongs on the haft-seen table, and when to order.',
    path: '/blog/nowruz-flowers',
  },
  {
    label: 'Seasonal guide',
    title: 'Peony Season in Canada',
    excerpt:
      'When local peonies bloom, how imports stretch the season, the marshmallow-bud buying trick, and wedding-ordering tips.',
    path: '/blog/peony-season-canada',
  },
  {
    label: 'Occasion guide',
    title: 'Prom Flowers: Corsage & Boutonniere Guide',
    excerpt:
      'Who buys what, wrist vs pin-on, matching colours to the dress, GTA prices, and how to pin a boutonniere properly.',
    path: '/blog/prom-flowers',
  },
];

const shopLinks = [
  { label: 'Flower Delivery', path: '/flower-delivery' },
  { label: 'Gift Delivery', path: '/gift-delivery' },
  { label: 'Rose Delivery', path: '/rose-delivery' },
];

const articleFilters = [
  { key: 'all', label: 'All posts' },
  { key: 'birth', label: 'Birth flowers' },
  { key: 'meaning', label: 'Flower meanings' },
  { key: 'colours', label: 'Flower colours' },
  { key: 'formats', label: 'Flower formats' },
  { key: 'occasions', label: 'Occasions' },
  { key: 'seasonal', label: 'Seasonal' },
  { key: 'gifts', label: 'Gift ideas' },
  { key: 'balloons', label: 'Balloons' },
  { key: 'plants', label: 'Plants' },
];

const findBlogArticleImage = path => {
  const article = Object.values(blogArticles).find(item => item.path === path);
  return article?.heroImage || null;
};

const getArticleFilterKey = article => {
  const label = article.label.toLowerCase();
  const title = article.title.toLowerCase();

  if (label.includes('birth') || title.includes('birth flower')) {
    return 'birth';
  }

  if (label.includes('meaning') || title.startsWith('meaning of')) {
    return 'meaning';
  }

  if (label.includes('colour') || label.includes('color')) {
    return 'colours';
  }

  if (label.includes('format')) {
    return 'formats';
  }

  if (label.includes('occasions') || title.startsWith('best flowers for')) {
    return 'occasions';
  }

  if (
    label.includes('seasonal') ||
    title.includes('valentine') ||
    title.includes("mother's day") ||
    title.includes('national flower day')
  ) {
    return 'seasonal';
  }

  if (label.includes('balloon') || title.includes('balloon')) {
    return 'balloons';
  }

  if (label.includes('plant') || title.includes('plant')) {
    return 'plants';
  }

  return 'gifts';
};

const BlogHubPage = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const config = useConfiguration();
  const rootUrl = config?.marketplaceRootURL || 'https://localflower.ca';
  const filteredArticles =
    activeFilter === 'all'
      ? featuredArticles
      : featuredArticles.filter(article => getArticleFilterKey(article) === activeFilter);

  const title = 'LocalFlower Blog | Flower Guides, Gift Ideas & Seasonal Articles';
  const description =
    'Explore LocalFlower articles about flower meanings, seasonal gifting, birth flowers, rose symbolism, Valentine ideas, and more.';
  const socialSharing = {
    title,
    description,
  };

  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: 'LocalFlower Blog',
      description,
      url: `${rootUrl}/blog`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: rootUrl,
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Blog',
          item: `${rootUrl}/blog`,
        },
      ],
    },
  ];

  return (
    <Page
      title={title}
      description={description}
      socialSharing={socialSharing}
      schema={schema}
      className={css.root}
    >
      <Helmet>
        <link rel="canonical" href={`${rootUrl}/blog`} />
      </Helmet>
      <LayoutSingleColumn
        className={css.layoutWrapper}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <main className={css.content}>
          <section className={css.hero}>
            <div className={css.heroCopy}>
              <h1 className={css.title}>LocalFlower Blog</h1>
              <p className={css.description}>
                Flower meanings, seasonal ideas, gift guides, and birth flower stories all in one
                place. Start with a post below or browse by topic.
              </p>
            </div>
          </section>

          <section className={css.section} id="blog-posts">
            <div className={css.sectionHeader}>
              <h2 className={css.sectionTitle}>Browse blog posts</h2>
              <p className={css.sectionDescription}>
                Filter the library by topic, then open the guide that matches what you are trying
                to choose or send.
              </p>
            </div>
            <div className={css.filterBar} aria-label="Filter blog posts by topic">
              {articleFilters.map(filter => {
                const isActive = activeFilter === filter.key;

                return (
                  <button
                    className={`${css.filterButton} ${isActive ? css.filterButtonActive : ''}`}
                    type="button"
                    aria-pressed={isActive}
                    onClick={() => setActiveFilter(filter.key)}
                    key={filter.key}
                  >
                    {filter.label}
                  </button>
                );
              })}
            </div>
            <div className={css.articleSection}>
              <div className={css.articleGrid}>
                {filteredArticles.map(article => {
                  const articleImage = findBlogArticleImage(article.path);
                  const featuredImage = articleImage || article.image || null;

                  return (
                    <article
                      className={`${css.articleCard} ${
                        featuredImage ? css.articleCardWithImage : ''
                      }`}
                      key={article.path}
                    >
                      {featuredImage ? (
                        <a
                          className={css.articleImageLink}
                          href={article.path}
                          aria-label={article.title}
                        >
                          <div className={css.articleImageWrap}>
                            <img
                              className={css.articleImage}
                              src={featuredImage.src}
                              alt={featuredImage.alt || article.title}
                              width={featuredImage.width}
                              height={featuredImage.height}
                              loading="lazy"
                            />
                          </div>
                        </a>
                      ) : null}
                      <div className={css.articleCardBody}>
                        <p className={css.articleMeta}>{article.label}</p>
                        <h3 className={css.articleTitle}>{article.title}</h3>
                        <p className={css.articleExcerpt}>{article.excerpt}</p>
                      </div>
                      <a className={css.articleLink} href={article.path}>
                        Open article
                      </a>
                    </article>
                  );
                })}
              </div>
            </div>
          </section>

          <section className={css.section}>
            <div className={css.sectionHeader}>
              <h2 className={css.sectionTitle}>Browse by topic</h2>
              <p className={css.sectionDescription}>
                Pick the kind of guide you want to read next, from flower meanings to seasonal ideas
                and gifting inspiration.
              </p>
            </div>
            <div className={css.categoryGrid}>
              {articleCategories.map(category => (
                <article className={css.categoryCard} key={category.title}>
                  <h3 className={css.categoryTitle}>{category.title}</h3>
                  <p className={css.categoryText}>{category.text}</p>
                </article>
              ))}
            </div>
          </section>

          <section className={css.section}>
            <div className={css.bottomGrid}>
              <article className={css.ctaPanel}>
                <h2 className={css.ctaTitle}>Need flowers or gifts today?</h2>
                <p className={css.ctaText}>
                  Jump back into the main shopping paths whenever you are ready to browse bouquets,
                  roses, or gifts.
                </p>
                <div className={css.ctaLinks}>
                  {shopLinks.map(link => (
                    <a className={css.ctaLink} href={link.path} key={link.path}>
                      {link.label}
                    </a>
                  ))}
                </div>
              </article>
              <article className={css.notesPanel}>
                <h2 className={css.notesTitle}>What you will find here</h2>
                <p className={css.notesText}>
                  Expect practical flower advice, color meanings, gifting ideas, seasonal reads, and
                  blog guides that make choosing the right flowers easier.
                </p>
              </article>
            </div>
          </section>
        </main>
      </LayoutSingleColumn>
    </Page>
  );
};

export default BlogHubPage;
